import mirrorCreator from "mirror-creator";

export default mirrorCreator(["READ_ALL_NOTIFICATIONS", "READ_NOTIFICATION", "TOGGLE_FAVORITE_NOTIFICATION"]);
